import {
    API_ROOT,
    API_UCENTER
} from 'apiConfig'

var api = {
    ads: API_ROOT.concat('/analystads'),
    analystInfo: '/json/analyst/analyst.json',
    articleList: API_ROOT.concat('/article'),
    // dynamicList: '/json/analyst/dynamic.json',
    dynamicList: API_ROOT.concat('/dynamic'),
    // salonList: '/json/salon/salonList.json'
    salonList: API_ROOT.concat('/analystsalon'),
    praiseDynamic: API_ROOT.concat('/praise'),
    symbolList: API_UCENTER.concat('/getSymbolList'),
    followAnalyst: API_ROOT.concat('/follow'),
    accountList: API_UCENTER.concat('/getMyAccount'),
    askAnalyst: API_ROOT.concat('/privateAsk') //一对一提问

}

// 广告列表接口
export const Ads = api.ads

// 分析师信息
export const AnalystInfo = api.analystInfo

// 分析师个人主页文章列表
export const ArticleList = api.articleList

// 分析师个人主页动态列表
export const DynamicList = api.dynamicList

// 分析师个人主页沙龙列表
export const SalonList = api.salonList

// 分析师动态点赞
export const PraiseDynamic = api.praiseDynamic

// 行情列表
export const SymbolList = api.symbolList

// 关注分析师
export const FollowAnalyst = api.followAnalyst

// 获取账户列表
export const AccountList = api.accountList

// 分析师一对一提问
export const AskAnalyst = api.askAnalyst



// WEBPACK FOOTER //
// ./src/service/analyst/api/address.js